/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import './styles.scss'

class MobileMenu {
  constructor (element) {
    this.$el = $(element)
    this.$el.find('.mainMenu-subNav').attr('aria-expanded', 'false')

    this.resetSubMenuState = this.resetSubMenuState.bind(this)
    this.closeSubMenu = this.closeSubMenu.bind(this)

    // MainMenu: Toggle
    this.$el.on('click', '.mobileMenu-button', () => {
      this.toggleMobileMenu()
      // SubMenu unfocusable while main menu is open
      this.$el.find('.subNav-link').attr('tabindex', '-1')
    })

    // After last element in main menu refocus on exit
    this.$el.on('focusout', '.utilityMenu-item:last-child a', (e) => {
      this.$el.find('.mobileMenu-button').focus()
    })

    // SubMenu after last element, refocus on back to main
    this.$el.on('focusout', '.subNav-item:last-child a', (e) => {
      this.$el.find('.mobileMenu-button--back').focus()
    })

    // Escape and it closes Menu
    this.$el.on('keydown', (e) => {
      if (e.which === 27) {
        this.toggleMobileMenu()
      }
    })

    // SubMenu: Open
    this.$el.on('click', '.mobileMenu-itemButton', (e) => {
      $(e.currentTarget).next('ul').addClass('mainMenu-subNav--active').attr('aria-expanded', 'true')
      $(e.currentTarget).next('ul').find('.subNav-link').attr('tabindex', '0')
      $(e.currentTarget).parents('.mobileMenu').addClass('mobileMenu-subNav--open')

      // Overide focus order in submenu
      this.$el.on('focusout', '.mobileMenu-button', () => {
        this.$el.find('.subNav-item:first-child a').focus()
      })
    })

    // SubMenu: Close
    this.$el.on('click', 'button[data-closeSubMenu="true"]', () => {
      this.resetSubMenuState()
      this.closeSubMenu()
    })
  }

  resetSubMenuState () {
    // Reset Submenu focus order
    this.$el.find('.subNav-link').attr('tabindex', '-1')
    this.$el.off('focusout', '.mobileMenu-button')

    if (this.$el.hasClass('mobileMenu--open')) {
      this.$el.find('.mobileMenu-button').focus()
    } else {
      this.$el.find('.mobileMenu-button').blur()
    }
  }

  closeSubMenu () {
    this.$el.removeClass('mobileMenu-subNav--open')
    this.$el.find('.mainMenu-subNav--active').attr('aria-expanded', 'false')
    this.$el.find('.mainMenu-subNav--active').removeClass('mainMenu-subNav--active')
  }

  toggleMobileMenu () {
    this.$el.toggleClass('mobileMenu--open')
    $('body').toggleClass('mobileMenu--present')
    this.resetSubMenuState()

    if (!this.$el.hasClass('mobileMenu--open')) {
      this.closeSubMenu()
    }
  }
}

registerClass('MobileMenu', MobileMenu)
